/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_PanelInputs */

const en_admin_panel = /** @type {(inputs: Admin_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin panel`)
};

const nl_admin_panel = /** @type {(inputs: Admin_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheerpaneel`)
};

/**
* | output |
* | --- |
* | "Admin panel" |
*
* @param {Admin_PanelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_panel = /** @type {((inputs?: Admin_PanelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_PanelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_admin_panel(inputs)
	return en_admin_panel(inputs)
});